var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.style.heroImageContainer, _vm.$style.heroImageContainer]},[_c('img',{class:_vm.$style.heroSectionChats,attrs:{"src":"/img/applicant_landing/hero_section_chats.svg","alt":""}}),_c('img',{class:_vm.$style.heroImage,attrs:{"src":"/img/applicant_landing/hero_section_image.png","alt":""}}),_c('upload-resume-block')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }